<!-- FirestoreドキュメントをJSON形式で編集できるモーダル -->
<script>
  import ModalCard from '../ModalCard.svelte'

  export let data
  export let ref
  export let title = 'デバッグ編集'

  let modal
  let value

  const handleShow = () => {
    value = JSON.stringify(data, null, '  ')
    modal.show()
  }

  const confirmHandler = () => {
    console.log(value)
    ref.set(JSON.parse(value))
    modal.hide()
  }
</script>

<button on:click={handleShow}>{title}</button>

<ModalCard {title} {confirmHandler} bind:this={modal}>
  <textarea name="" id="" cols="70" rows="40" bind:value />
</ModalCard>
